import React from 'react'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { IssueEntity } from 'types/IssueEntity'
import { DynamicIconButton } from '../../../utils/tooltip/DynamicIconButton'
import { FactsTableRow } from '../../components/FactsTable'
import { formatBigMoney } from '../../../packages/utils/numberFormatters'
import InfoIcon from '@mui/icons-material/Info'
import Stack from '@mui/material/Stack'

export function PreMoneyRow({ issue }: { issue: IssueEntity }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language
    return (
        <FactsTableRow
            label={
                <Stack
                    direction='row'
                    sx={{
                        alignItems: 'center',
                    }}
                >
                    <Typography>{t('pages.issues.terms.preMoney')}</Typography>
                    <DynamicIconButton
                        title={t('pages.issues.terms.preMoneyTooltip')}
                        IconComponent={InfoIcon}
                        placement='top'
                        padding='0px 4px'
                    />
                </Stack>
            }
        >
            {issue.preMoney !== null
                ? formatBigMoney(issue.preMoney, { locale, decimals: 0, currencySymbol: issue.currency, tooltip: true })
                : '-'}
        </FactsTableRow>
    )
}
